import { CONSTANT_QUERY_LIST } from '../gql/constant';

export const coreConstanteRepository = () => {
  // Composables
  const { apolloClient } = useApollo();

  const getConstantes = async () => {
    const constants: { data: CoreConstantsApiResponse } = await apolloClient.query({
      query: CONSTANT_QUERY_LIST,
    });
    return constants.data;
  };

  return {
    getConstantes,
  };
};
